import axios from 'axios'

export default {
  data() {
    return {
      tags: [],
      availableReservationTags: [],
    }
  },
  methods: {
    async _fetchTagsFromAPI(endpoint, targetProperty, sort = false) {
      try {
        const { data } = await axios.get(endpoint)
        this[targetProperty] = Array.from(
          new Set(data.filter(tag => tag && tag.trim()))
        )
        if (sort) this[targetProperty].sort()
      } catch (error) {
        console.error(`Error fetching tags for ${targetProperty}`, error)
      }
    },
    async fetchTags(sort = false) {
      await this._fetchTagsFromAPI('/api/listings/tags', 'tags', sort)
    },
    async fetchReservationTags(sort = false) {
      await this._fetchTagsFromAPI(
        '/api/reservations/tags',
        'availableReservationTags',
        sort
      )
    },
  },
}
